module.exports = __webpack_public_path__ + "img/additional.73d5f414.jpg";